var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 8,
    fill: "#CC1E24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2325 12.0109C23.3715 11.9718 22.6671 12.7153 22.6671 13.5763V16.9812H22.354V10.0932C22.354 9.23223 21.6104 8.48865 20.7494 8.52778C19.8884 8.52778 19.2231 9.23223 19.2231 10.0541V16.9812H18.91V8.56692C18.91 7.70593 18.1664 6.96234 17.3054 7.00148C16.4444 7.00148 15.7791 7.70593 15.7791 8.52778V16.9812H15.466V10.1324C15.466 9.27137 14.7224 8.52778 13.8615 8.56692C13.0005 8.56692 12.3351 9.27137 12.3351 10.0932V19.3293L11.0828 17.6465C10.574 16.942 9.59562 16.7855 8.89117 17.2943C8.18672 17.803 8.03018 18.7814 8.53895 19.4859L13.4701 26.2564C13.7832 26.726 14.3702 27 14.9964 27H22.7062C23.5672 27 24.3499 26.413 24.5456 25.552L25.5631 21.1687C25.7197 20.6208 25.7588 20.0338 25.7588 19.4467V13.5372C25.7979 12.7153 25.0935 12.0109 24.2325 12.0109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2ed9cf277464f90dbc4a721f4beb5a1c.svg";
export { ForwardRef as ReactComponent };